export const ACTION_TYPES = {
  REQUEST_OCCUPATIONS: 'REQUEST_OCCUPATIONS',
  RECEIVE_OCCUPATIONS: 'RECEIVE_OCCUPATIONS'
};

const initialState = { entities: [], isLoading: false };

export const actionCreators = {
  requestOccupations: () => async (dispatch) => {
    // if (getState().occupations.isfetch) {
    // Don't issue a duplicate request (we already have or are loading the requested data)
    //   return;
    // }
    dispatch({ type: ACTION_TYPES.REQUEST_OCCUPATIONS });

    const url = `api/occupation`;
    const response = await fetch(url);
    const entities = await response.json();

    dispatch({ type: ACTION_TYPES.RECEIVE_OCCUPATIONS, entities });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case (ACTION_TYPES.REQUEST_OCCUPATIONS):
      return {
        ...state,
        isLoading: true
      };
      case (ACTION_TYPES.RECEIVE_OCCUPATIONS):
      return {
        ...state,
        isLoading: false,
        entities: action.entities
      }
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/store/Occupations.js